import { isEmpty } from "lodash-es";
import { messageTypes } from "utils/static";

/**
 * Builds POST /WA/conversations/messages body (same contract as create chat drawer).
 *
 * @param {object} values Form values from create-chat style form
 * @param {number} phone_number_id WhatsApp channel id (not from Redux)
 * @returns {object} payload
 */
export function buildConversationMessagePayload(values, phone_number_id) {
  const payload = {
    phone_number_id,
    message_text: values.message_text,
    type_id: messageTypes.TEXT,
  };

  if (values.receiver_type === "contact") {
    payload.contact_id = values.contact_id;
  } else {
    payload.to_phone_number = values.to_phone_number;
  }

  if (values.message_type === "template") {
    payload.type_id = messageTypes.TEMPLATE;
    payload.message_text = "";
    payload.template_id = values.template_id;

    if (!isEmpty(values.template_body)) {
      payload.template_body_params = values.template_body.map(
        (row) => row.value
      );
    }

    if (values.template_button_param) {
      payload.template_button_param = values.template_button_param;
    }

    if (!isEmpty(values?.attachment)) {
      payload.template_header_params = {
        [values.attachment[0].key]: values.attachment[0].metaId,
      };
      payload.media_document_filename =
        values.attachment[0].media_document_filename;
      payload.media_url = values.attachment[0].metaId;
    }
  }

  return payload;
}
